<template>
  <div class="about">
    <header>
      <div class="banner">
        <h3>关于我们</h3>
        <h4>信易达成立于2018年10月，是一家致力于国产自主可控软硬件产品研发、生产、销售的高科技企业</h4>
      </div>
      <div class="banner-office">
        <transition
          enter-active-class="animate__animated animate__bounceInLeft"
          leave-active-class="animate__animated animate__fadeOut"
        >
          <div class="office" v-show="isShow">
            <img src="@/assets/imgstore/about-office.png">
          </div>
        </transition>
        <transition
          enter-active-class="animate__animated animate__bounceInRight banner-info"
          leave-active-class="animate__animated animate__fadeOut"
        >
          <div class="info" v-show="isShow">
            <h4>公司简介</h4>
            <p>南京信易达计算技术有限公司成立于2018 年10月4日，注册在中国(江苏)自由贸易试验区。信易达是一家致力于国产自主可控软硬件产品研发、生产、销售的高科技 企业，拥有超算中心建设、部署、运营的 自主可控一体化解决方案，产品和服务覆 盖政府、军工、高校、金融、医疗及科研等行业。</p>
          </div>
        </transition>
      </div>
    </header>
    <div class="main">
      <section>
        <img src="@/assets/imgstore/about-prod1.png">
        <h4>高性能存储<br/>CompubiqStor</h4>
        <p>
          — 国产自主可控<br/>
          — 全定制专用存储系统<br/>
          — SAN、NAS融合型存储<br/>
          — 高可靠、高可用、高性能</p>
      </section>
      <section>
        <img src="@/assets/imgstore/about-prod2.png">
        <h4>超算运维管理软件<br/>ClusterMom</h4>
        <p>
          — 资源监控<br/>
          — 作业管理<br/>
          — 计费统计<br/>
          — 告警预警
        </p>
      </section>
      <section>
        <img src="@/assets/imgstore/about-prod3.png">
        <h4>高性能应用容器<br/>CompubiqContainer</h4>
        <p>
          — 打包应用程序，开箱即用<br/>
          — 去繁就简、解决最后一公里问题<br/>
          — 原支持MPI与GPU<br/>
          — 平台间可无缝迁移</p>
      </section>
    </div>
    <div class="cert-wrapper">
      <div class="cert-cont">
        <h3>公司资质</h3>
        <p>公司非常重视科技创新，不断加大研发投入，取得了显著成果，已获得科技中小、国家高新技术企业认定等政府荣誉资质。截止2020年底，<br/>公司已获得专利证书6项、软件著作权证书12项、商标证书10项，并已获得ISO9001质量管理体系认证证书。</p>
        <div class="cert">
          <div>
            <img src="@/assets/imgstore/cert1s.png">
          </div>
          <div>
            <img src="@/assets/imgstore/cert2s.png">
          </div>
          <div>
            <img src="@/assets/imgstore/cert3s.png">
          </div>
          <div>
            <img src="@/assets/imgstore/cert4s.png">
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-cont">
        <div class="logo">
          <img src="@/assets/imgs/logo.png">
        </div>
        <div class="contact">
          <h4>联系我们</h4>
          <p>地址：南京市江北新区腾飞大厦A座4楼</p>
          <p>电话：025-68155007</p>
        </div>
        <div class="qr">
          <img class="tu" src="@/assets/imgs/home-qr.png">
          <br>
          <span class="spa">关注我们</span>
        </div>
      </div>
    </div>
    <div class="footer footer2">
      <p>版权所有 © 南京信易达计算技术有限公司 <a style="color: rgba(255,255,255, .4);" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备2021021510号-1</a> 苏公网安备 0000000000号</p>
    </div>
  </div>
</template>

<script>
import store from "../store.js";
import "animate.css";
export default {
  name: "home",
  data() {
    return {
      isShow: false,
      state: store.state,
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0);
      this.isShow = true;
    }, 100);
  },
  watch: {
    "state.scrollTop"(val, oldVal) {
      console.log("home scrollTop:", val, oldVal);
      this.isShow = val < 700;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.about {
  header {
    position: relative;
    height: 530px;
    background: #20367c url("../assets/imgstore/about-head.png") no-repeat;
    background-size: 100% auto;
    background-position: center;
  }
  .banner {
    width: 1200px;
    text-align: center;
    margin: 0 auto;
    padding-top: 100px;
    height: 330px;
    position: relative;
    h3, h4 {
      font-size: 60px;
      padding-bottom: 40px;
      color: #fff;
    }
    h4 {
      opacity: .8;
      font-size: 26px;
      line-height: 40px;
    }
  }

  .banner-office {
    position: absolute;
    background: #fff;
    width: 1200px;
    height: 339px;
    left: 0;
    right: 0;
    margin: auto;
    bottom: -210px;
    display: flex;
    box-shadow: 0 0 6px rgba(0, 0, 0, .3);
    .office {
      width: 555px;
      height: 100%;
      z-index: 1;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .info {
      flex: 1;
      background: #fff;
      height: 100%;
      z-index: 2;
      padding: 50px 30px;
      box-sizing: border-box;
      line-height: 30px;
      font-size: 16px;
      color: #5B6783;
      h4 {
        font-size: 36px;
        padding-bottom: 20px;
      }
    }
    .banner-info {
      animation-delay: 300ms;
    }
  }
}
.main {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 300px auto 50px;
  section {
    width: 25%;
    padding: 3%;
    text-align: left;
    border: 1px solid #DBE6F5;
    border-radius: 10px;
    color: #465373;
  }
  section img {
    width: 50px;
    display: block;
    margin-bottom: 5%;
  }
  section h4 {
    font-size: 24px;
    color: #465373;
    margin-bottom: 3%;
  }
  section p {
    line-height: 30px;
    color: #465373;
    font-size: 16px;
  }
}

.cert-wrapper {
  background: #f8f6f6;
  align-content: center;
  width: 100%;
  padding: 50px 0 100px;
  height: 500px;
  text-align: center;
  .cert-cont {
    width: 1200px;
    margin: 0 auto;
    color: #5B6783;
    line-height: 40px;
  }
  h3 {
    padding-bottom: 40px;
    font-size: 35px;
    color: #465373;
  }
  .cert {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    // background: #fff;
    // box-shadow: 0 0 10px #cccccc;
  }
  .cert div {
    flex-grow: 1;
    padding: 30px;
    height: 300px;
    text-align: center;
  }
  .cert div img {
    height: 100%;
    cursor: pointer;
    transition: 500ms all;
    &:hover {
      transform: scale(1.5);
    }
  }
}

.footer {
  background: #2b2b2b;
  // height: 100px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  .footer-cont {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    .logo {
      width: 130px;
      padding: 20px 0 0;
      img {
        width: 120px;
        background: rgba(255, 255, 255, .9);
        padding: 5px 8px;
        border-radius: 5px;
      }
    }
    .contact {
      flex: 1;
      padding: 20px 0 0 10%;
      line-height: 26px;
      h4 {
        color: rgba(255, 255, 255, 0.69);
        font-size: 16px;
        padding-bottom: 10px;
      }
    }
    .qr {
      width: 80px;
      padding: 20px 0;
      text-align: center;
      img {
        width: 80px;
        margin-bottom: 10px;
      }
    }
  }
}
.footer2 {
  background: #2b2b2b;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
}

@keyframes imgRotate {
  0 {
    opacity: 1;
    transform: rotate(0deg);
  }
  50% {
    opacity: 0.7;
    transform: rotate(180deg) scale(1.1);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg);
  }
}

@keyframes shine {
  0 {
    opacity: 1;
  }
  50% {
    opacity: 0.9;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue